import { Flex, Text, RadioButtonCheckedIcon, RadioButtonUncheckedIcon } from '@shared/components';

interface Option {
  label: string;
  icon: React.ReactNode;
  checked?: boolean;
}

export interface ReadonlyRadioWithIconSelectionProps {
  label: string;
  options: Array<Option>;
  row?: boolean;
  helperText?: string;
  required?: boolean;
}

export default function ReadonlyRadioWithIconSelection(
  props: Readonly<ReadonlyRadioWithIconSelectionProps>,
) {
  const { label, options, row: hasRow, helperText, required } = props;

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(2), flexDirection: 'column' })}>
      <Text variant='body2Semibold'>
        {label}
        {required ? (
          <Text
            component='span'
            color='error.main'
            sx={{
              ml: (theme) => theme.spacing(1),
            }}
          >
            *
          </Text>
        ) : null}
      </Text>
      <Flex
        sx={{
          gap: (theme) => theme.spacing(3),
          flexDirection: hasRow ? 'row' : 'column',
        }}
      >
        {options.map((option) => (
          <Flex
            key={option.label}
            sx={(theme) => ({
              alignItems: 'center',
              flexDirection: hasRow ? 'row' : 'column',
              bgcolor: theme.palette.grey[100],
              color: theme.palette.grey[600],
              p: theme.spacing(3, 4),
              borderRadius: theme.shape.rounded(1.5),
              minWidth: '200px',
            })}
          >
            {option.icon}
            <Text
              sx={(theme) => ({
                color: theme.palette.text.primary,
                flex: 1,
                ml: theme.spacing(2),
                mr: theme.spacing(4),
              })}
            >
              {option.label}
            </Text>
            {option.checked ? (
              <RadioButtonCheckedIcon
                sx={{
                  color: (theme) => theme.palette.grey[500],
                }}
              />
            ) : (
              <RadioButtonUncheckedIcon
                sx={{
                  color: (theme) => theme.palette.grey[500],
                }}
              />
            )}
          </Flex>
        ))}
      </Flex>
      {helperText ? <Text variant='caption'>{helperText}</Text> : null}
    </Flex>
  );
}
ReadonlyRadioWithIconSelection.displayName = 'ReadonlyRadioWithIconSelection';
